import { resolveComponent as c, openBlock as r, createElementBlock as i, normalizeClass as m, createElementVNode as o, renderSlot as x, createBlock as w, createCommentVNode as k, createVNode as n, withCtx as h, toDisplayString as d, Fragment as v, renderList as B } from "vue";
import { _ as b } from "./_plugin-vue_export-helper-dad06003.js";
import { A as C } from "./ArrowDownIcon-31fc6a85.js";
import { A } from "./ArrowLeftIcon-c3971030.js";
import { A as I } from "./ArrowRightIcon-4b3ad31a.js";
import { L as T } from "./LinkGrayMd-9ecb8e08.js";
import { B as M } from "./ButtonSecondaryIconMd-da7e4388.js";
const R = {
  name: "TableHeader",
  components: {
    ArrowDownIcon: C
  },
  props: {
    textRight: {
      type: Boolean,
      default: !1
    },
    smHidden: {
      type: Boolean,
      default: !1
    },
    sortable: {
      type: Boolean,
      default: !1
    },
    sort: {
      type: Number,
      default: null
    }
  },
  emits: ["update:sort"],
  computed: {
    model: {
      get() {
        return this.sort;
      },
      set(l) {
        this.$emit("update:sort", l);
      }
    }
  },
  methods: {
    changeModel() {
      this.model === 1 ? this.model = -1 : this.model === -1 ? this.model = null : this.model = 1;
    }
  }
};
function L(l, a, e, _, p, t) {
  const u = c("ArrowDownIcon");
  return r(), i("th", {
    scope: "col",
    class: m(["px-6 py-3 text-sm font-medium ct-text-1", [
      e.smHidden ? "hidden sm:table-cell" : "table-cell",
      e.sortable ? "cursor-pointer" : ""
    ]]),
    onClick: a[0] || (a[0] = (...f) => t.changeModel && t.changeModel(...f))
  }, [
    o("div", {
      class: m(["flex items-center space-x-2", [e.textRight ? "justify-end" : "justify-start"]])
    }, [
      x(l.$slots, "default"),
      e.sortable ? (r(), w(u, {
        key: 0,
        class: m(["h-4 w-4 ct-fg-3 transform transition", [
          t.model > 0 ? "rotate-180" : "rotate-0",
          t.model ? "opacity-100" : "opacity-0"
        ]])
      }, null, 8, ["class"])) : k("", !0)
    ], 2)
  ], 2);
}
const oe = /* @__PURE__ */ b(R, [["render", L]]), N = {
  name: "TableCell",
  props: {
    textRight: {
      type: Boolean,
      default: !1
    },
    smHidden: {
      type: Boolean,
      default: !1
    },
    wrapText: {
      type: Boolean,
      default: !1
    },
    alignTop: {
      type: Boolean,
      default: !1
    },
    truncate: {
      type: Boolean,
      default: !1
    },
    colSpan: {
      type: Number,
      default: 1
    }
  }
}, S = ["colspan"];
function H(l, a, e, _, p, t) {
  return r(), i("td", {
    class: m(["h-16 px-4 sm:px-6 text-sm ct-text-1", [
      e.textRight ? "text-right" : "text-left",
      e.smHidden ? "hidden sm:table-cell" : "",
      e.wrapText ? "whitespace-normal ct-word-breaks" : "whitespace-nowrap ",
      e.truncate ? "w-full max-w-0 sm:w-auto sm:max-w-none" : "",
      e.alignTop ? "align-top" : ""
    ]]),
    colspan: e.colSpan
  }, [
    x(l.$slots, "default")
  ], 10, S);
}
const se = /* @__PURE__ */ b(N, [["render", H]]), j = {
  name: "TableContainer",
  props: {
    noBorder: {
      type: Boolean,
      default: !1
    }
  }
}, D = { class: "border-b border-gray-300 dark:border-neutral-700" }, P = { class: "divide-y divide-gray-200 dark:divide-neutral-800" };
function G(l, a, e, _, p, t) {
  return r(), i("table", {
    class: m(["ct-table min-w-full", [e.noBorder ? "" : "border-b border-gray-200 dark:border-neutral-800"]])
  }, [
    o("thead", D, [
      x(l.$slots, "headers")
    ]),
    o("tbody", P, [
      x(l.$slots, "body")
    ])
  ], 2);
}
const ne = /* @__PURE__ */ b(j, [["render", G]]), E = {
  name: "TablePagination",
  components: {
    ArrowLeftIcon: A,
    ArrowRightIcon: I,
    LinkGrayMd: T,
    ButtonSecondaryIconMd: M
  },
  props: {
    modelValue: {
      type: Number,
      default: 1
    },
    maxValue: {
      type: Number,
      default: 1
    },
    texts: {
      type: Object,
      default: () => ({
        previous: "Previous",
        next: "Next",
        page: "Page",
        of: "of"
      })
    }
  },
  emits: ["update:modelValue"],
  computed: {
    model: {
      get() {
        return this.modelValue;
      },
      set(l) {
        this.$emit("update:modelValue", +l);
      }
    },
    valuesRange() {
      return this.maxValue > 7 ? this.modelValue > 5 && this.modelValue <= this.maxValue - 4 ? [
        1,
        "...",
        this.modelValue - 2,
        this.modelValue - 1,
        this.modelValue,
        this.modelValue + 1,
        this.modelValue + 2,
        "...",
        this.maxValue
      ] : this.modelValue > 5 && this.modelValue > this.maxValue - 4 ? [
        1,
        "...",
        this.maxValue - 4,
        this.maxValue - 3,
        this.maxValue - 2,
        this.maxValue - 1,
        this.maxValue
      ] : [1, 2, 3, 4, 5, 6, "...", this.maxValue] : Array.from({ length: this.maxValue }, (l, a) => a + 1);
    }
  }
}, $ = { class: "w-full flex items-center justify-between" }, z = { class: "hidden sm:flex space-x-1.5 items-center" }, F = { class: "block sm:hidden" }, O = { class: "hidden sm:flex space-x-0.5" }, q = ["disabled", "onClick"], J = { class: "block sm:hidden text-sm font-medium ct-fg-2" }, K = { class: "hidden sm:flex space-x-1.5 items-center" }, Q = { class: "block sm:hidden" };
function U(l, a, e, _, p, t) {
  const u = c("ArrowLeftIcon"), f = c("LinkGrayMd"), y = c("ButtonSecondaryIconMd"), g = c("ArrowRightIcon");
  return r(), i("div", $, [
    o("div", z, [
      n(f, {
        disabled: t.model === 1,
        onClick: a[0] || (a[0] = (s) => t.model--)
      }, {
        default: h(() => [
          n(u),
          o("span", null, d(e.texts.previous), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    o("div", F, [
      n(y, {
        disabled: t.model === 1,
        onClick: a[1] || (a[1] = (s) => t.model--)
      }, {
        default: h(() => [
          n(u)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    o("div", O, [
      (r(!0), i(v, null, B(t.valuesRange, (s, V) => (r(), i("button", {
        key: V,
        type: "button",
        class: m(["w-10 h-10 rounded-lg flex items-center justify-center text-sm font-medium", [
          s === t.model ? "text-gray-700 dark:text-neutral-300 bg-gray-50 dark:bg-neutral-800" : "ct-text-3 ",
          s === "..." ? "cursor-default ct-fg-disabled" : "cursor-pointer hover:text-gray-700 dark:hover:text-neutral-300 hover:ct-bg-1"
        ]]),
        disabled: s === "...",
        onClick: (W) => t.model = s
      }, d(s), 11, q))), 128))
    ]),
    o("p", J, d(e.texts.page) + " " + d(t.model) + " " + d(e.texts.of) + " " + d(e.maxValue), 1),
    o("div", K, [
      n(f, {
        disabled: t.model === e.maxValue,
        onClick: a[2] || (a[2] = (s) => t.model++)
      }, {
        default: h(() => [
          o("span", null, d(e.texts.next), 1),
          n(g)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    o("div", Q, [
      n(y, {
        disabled: t.model === e.maxValue,
        onClick: a[3] || (a[3] = (s) => t.model++)
      }, {
        default: h(() => [
          n(g)
        ]),
        _: 1
      }, 8, ["disabled"])
    ])
  ]);
}
const de = /* @__PURE__ */ b(E, [["render", U]]);
export {
  se as TableCell,
  ne as TableContainer,
  oe as TableHeader,
  de as TablePagination
};
